<app-spinner-overlay></app-spinner-overlay>
<div class="dialog-backdrop">
  <div class="dialog-container">
    <!-- Icon + Title -->
    <div class="icon-title-section">
      @if (isFileNode(data.fileFolder)) {
        <img [src]="getLogoFile(data.fileFolder)" alt="icon" class="file-icon" />
      } @else {
        <mat-icon>
          {{
            hasSottoCartelle(data.fileFolder) || hasFile(data.fileFolder) ? 'folder' : 'folder_open'
          }}
        </mat-icon>
      }
      <h2 class="dialog-title">{{ data.fileFolder.name }}</h2>
      <p class="dialog-subtitle">{{ data.fileFolder.size | byteFormatter }}</p>
    </div>

    <!-- Main Card -->
    <div class="dialog-card">
      <!-- Utente Creazione -->
      <div class="dialog-row">
        <div class="row-label">Utente</div>
        <div class="row-value">{{ nomeUtente }}</div>
      </div>
      <!-- Directory Path -->
      <div class="dialog-row">
        <div class="row-label">Percorso</div>
        <div class="row-value">{{ getVisiblePath() }}</div>
      </div>

      @if (!$any(data.fileFolder).locked) {
        <!-- CARICATO -->
        <div class="dialog-row">
          <div class="row-label">{{ isFileNode(data.fileFolder) ? 'Caricato' : 'Creazione' }}</div>
          <div class="row-value">{{ data.fileFolder.createdAt | formatDate }}</div>
        </div>
      }
      @if (isFileNode(data.fileFolder)) {
        <!-- EXTENSION -->
        <div class="dialog-row">
          <div class="row-label">Estensione</div>
          <div class="row-value">{{ data.fileFolder.extension }}</div>
        </div>
      }

      <!-- DIMENSIONE -->
      <div class="dialog-row">
        <div class="row-label">Dimensione</div>
        <div class="row-value">
          {{ data.fileFolder.size | byteFormatter }} ({{ data.fileFolder.size }} bytes)
        </div>
      </div>

      <!-- NUMERO FILE -->
      @if (!isFileNode(data.fileFolder)) {
        <div class="dialog-row">
          <div class="row-label">Numero Files</div>
          <div class="row-value">{{ data.fileFolder.fileCounter }}</div>
        </div>
      }
      <div class="btn-chiudi">
        <button mat-dialog-close mat-flat-button color="accent" class="accent-button">
          Chiudi
        </button>
      </div>
    </div>
  </div>
</div>
